import { Component } from 'react';
import PropTypes from 'prop-types';

export default class ThemeProvider extends Component {
  getChildContext = () => ({
    themes: this.props.themes,
  });

  render() {
    return this.props.children;
  }
}

ThemeProvider.childContextTypes = {
  themes: PropTypes.object,
};

ThemeProvider.propTypes = {
  themes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};
